/**
 * Серверный settle матча: единственный источник правды для денег.
 * Клиент только триггерит, сервер атомарно списывает/начисляет.
 */
import { getAuth } from "firebase/auth";

export interface MatchSettleRequest {
  matchId: string;
  winnerUid: string;
  loserUid: string;
  bet: number;
  isGammon: boolean;
  isBackgammon: boolean;
  isMatchWin: boolean;
}

export interface MatchSettleResponse {
  ok: boolean;
  yourDelta: number;
  winnerDelta: number;
  loserDelta: number;
  alreadyApplied: boolean;
}

export async function settleMatchOnServer(
  req: MatchSettleRequest
): Promise<MatchSettleResponse | null> {
  try {
    const user = getAuth().currentUser;
    if (!user) return null;
    const idToken = await user.getIdToken();

    const resp = await fetch("/api/match/settle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify(req),
    });

    if (!resp.ok) {
      const txt = await resp.text();
      console.error("settleMatchOnServer failed:", resp.status, txt);
      return null;
    }
    return (await resp.json()) as MatchSettleResponse;
  } catch (err) {
    console.error("settleMatchOnServer exception:", err);
    return null;
  }
}
